import { Injectable } from '@angular/core';
import { Connection, ConnectionDataMap, ConnectionType } from '../interfaces/connection-interface';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConnectionStateService {
  private currentConnection$ = new BehaviorSubject<Connection | null>(null);

  setConnection(connection: Connection | null): void {
    this.currentConnection$.next(connection);
  }

  setNewConnection<T extends ConnectionType>(type: T, name = ''): void {
    const base: Connection = {
      id: Date.now(),
      name: name || `Nueva conexión ${type.toUpperCase()}-${Date.now()}`,
      type,
      owner: 1,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      is_active: true,
      data: this.getEmptyDataByType(type),
    } as Connection;

    this.setConnection(base);
  }

  getCurrentConnection(): Observable<Connection | null> {
    return this.currentConnection$.asObservable();
  }

  private getEmptyDataByType<T extends ConnectionType>(type: T): ConnectionDataMap[T] {
    switch (type) {
      case 'postgresql':
        return {
          host: '',
          port: 5432,
          user: '',
          dbname: '',
          password: '',
        } as ConnectionDataMap[T];

      case 'ftp':
        return {
          name: '',
          host: '',
          port: '',
          user: '',
          password: '',
        } as ConnectionDataMap[T];

      case 'sftp':
        return {
          name: '',
          host: '',
          port: '',
          user: '',
          password: '',
        } as ConnectionDataMap[T];

      case 'rest':
        return {
          base_url: '',
          headers: {},
          auth_type: 'api_key',
          auth_api_key_header_name: '',
          auth_api_key_header_value: '',
        } as ConnectionDataMap[T];

      case 'restlet':
        return {
          token_id: '',
          account_id: '',
          restlet_url: '',
          consumer_key: '',
          consumer_secret: '',
          token_secret: '',
        } as ConnectionDataMap[T];

      case 'netsuite':
        return {
          name: '',
          account: '',
          consumer_key: '',
          consumer_secret: '',
          token_key: '',
          token_secret: '',
          realm: '',
          script_id: '',
          deploy_id: '',
        } as ConnectionDataMap[T];

      default:
        return {} as ConnectionDataMap[T];
    }
  }
}
